/* const utils = require('./helpers/utils');
const breakpointPX = 767; */
import axios from 'axios'
const merge = require('deepmerge')
const AUTOCOMPLETE_PATH = 'autocomplete'
const GEOCODE_PATH = 'geocode'
const SEARCH_PATH = 'policies'

const ANALYTICS_PARAMS = {
  CATEGORIES: {
    VISITA: 'visitas',
    DIRECCION: 'direccion',
    ORIGEN: 'origen',
    DISPONIBILIDAD: 'disponibilidad'
  },
  LABELS: {
    VISITA: 'visita_pide_tu_bombona',
    CON_NUMERO: 'con_numero',
    CON_NUMERO_ERRONEO: 'con_numero_error',
    SIN_NUMERO: 'sin_numero',
    REPSOL: 'repsol',
    GOOGLE: 'google',
    NO_EXISTE: 'no-existe',
    AGENCIA_ASIGNADA: 'agencia-asignada'
  },
  ACTIONS: {
    VISITA: 'gas - visitas - pide tu bombona',
    DIR_CON_NUMERO: 'gas - direccion con numero',
    DIR_CON_NUMERO_ERRONEO: 'gas - direccion con numero erroneo',
    DIR_SIN_NUMERO: 'gas - direccion sin numero',
    DIR_NO_EXISTE: 'gas - no disponible - no encuentro mi calle',
    ORIGEN: 'gas - seleccion calle - origen ',
    ORIGEN_REPSOL: 'gas - seleccion calle - origen repsol',
    AGENCIA_ASIGNADA: 'gas - agencia asignada'
  }
}

export default {
  name: 'AutocompleteComponent',

  data() {
    return {
      defaultConfig: require('./defaultConfig/config.json'),
      config: null,
      locationFromSearch: null,
      mobile: null,
      items: [],
      isOpen: false,
      searchTerm: '',
      arrowCounter: 0,
      noResults: false,
      apiUrl: process.env.API_AUTOCOMPLETE_URL,
      notNumber: false,
      streetNumber: '',
      gettingItems: false
    }
  },
  props: {
    location: {
      type: String,
      required: false
    },
    configuration: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    mappedItems: function() {
      return this.items.map(item => {
        const autocompleteContent = item.fullAddress
        const match = autocompleteContent.toLowerCase().match(this.searchTerm.toLowerCase())
        let substr = ';'
        if (match) {
          const index = match.index
          substr = autocompleteContent.substr(index, this.searchTerm.length)
        }
        item.autocompleteContent = autocompleteContent.replace(substr, `<strong>${substr}</strong>`)
        return item
      })
    }
  },
  watch: {
    items: function(newItems) {
      this.noResults = newItems.length === 0
      if (this.noResults) {
        this.trackerGAEvent(
          ANALYTICS_PARAMS.CATEGORIES.DISPONIBILIDAD,
          `${ANALYTICS_PARAMS.ACTIONS.DIR_NO_EXISTE}`,
          this.searchTerm
        )
      }
    },
    location: function(newLocation) {
      this.locationFromSearch = newLocation
    }
  },
  methods: {
    async getItems() {
      if (!this.gettingItems) {
        this.gettingItems = true
        if (this.timeout) clearTimeout(this.timeout)
        this.timeout = setTimeout(async () => {
          this.sendEditEvent(true)
          if (this.searchTerm.length === 0) {
            this.clearItem()
          }
          if (this.searchTerm.length >= this.config.typedLength && this.selectedItem !== this.searchTerm) {
            this.items = await this.searchAutocomplete(this.searchTerm)
            this.isOpen = true
          } else {
            this.isOpen = false
          }
          this.gettingItems = false
        }, this.config.searchTimeout)
      }
    },
    async searchWithNumber() {
      if (this.timeout) clearTimeout(this.timeout)
      this.timeout = setTimeout(async () => {
        if (this.streetNumber.length === 0) {
          this.clearNumber()
        } else {
          let selectedItem = await this.searchGeocodeAddress(this.selectedItemWithoutNumber)
          this.emitSelectItem(selectedItem)
        }
      }, this.config.searchTimeout)
    },

    async searchGeocodeAddress(selectedItemWithoutNumber) {
      let selectedItem
      if (!this.editing && this.streetNumber) {
        if (selectedItemWithoutNumber.origin === 'google') {
          const address = this.concatNumberInGoogleAddress(this.searchTerm, this.streetNumber)
          selectedItem = await this.geocodeByAddress(address)
        } else if (selectedItemWithoutNumber.neutral) {
          selectedItemWithoutNumber.number = this.streetNumber
          selectedItem = await this.searchRepsol(selectedItemWithoutNumber)
        } else {
          selectedItem = await this.geocodeByPlaceId(selectedItemWithoutNumber.placeId)
          selectedItem.number = this.streetNumber
        }
      }
      return selectedItem
    },

    async selectItem(item) {
      this.setResult(item)
      let selectedItem = item
      if ((item.origin === 'google' || item.neutral) && !item.lat && !item.lng) {
        if (item.placeId && item.number) {
          selectedItem = await this.geocodeByPlaceId(item.placeId, item.number)
        } else if (this.streetNumber) {
          selectedItem = await this.searchGeocodeAddress(item)
        } else {
          this.selectedItemWithoutNumber = item
          selectedItem = null
          this.notNumber = true
        }
        const { street, locality } = this.parseFullAddress(item.fullAddress)
        this.trackerGAEvent(
          ANALYTICS_PARAMS.CATEGORIES.DISPONIBILIDAD,
          `${ANALYTICS_PARAMS.ACTIONS.ORIGEN}${item.origin}`,
          `${street} ${locality}`
        )
      } else if (item.origin === 'repsol') {
        this.trackerGAEvent(
          ANALYTICS_PARAMS.CATEGORIES.DISPONIBILIDAD,
          `${ANALYTICS_PARAMS.ACTIONS.ORIGEN_REPSOL}`,
          `${item.streetType} ${item.street} ${item.locality}`
        )
      }
      if (item.number) {
        this.notNumber = false
        this.streetNumber = ''
      }
      this.emitSelectItem(selectedItem)
    },
    async emitSelectItem(item) {
      if (item && !this.editing) {
        item.autocompleteContent = this.selectedItem
        this.$emit('select-item', item)
      }
    },

    clearItem() {
      this.selectedItem = ''
      this.isOpen = false
      this.gettingItems = false
      this.notNumber = false
      this.searchTerm = ''
      this.streetNumber = ''
      this.$refs.autocompleteInput.focus()
      this.$emit('clear-item')
    },
    sendEditEvent(editing) {
      if (this.editing !== editing) {
        this.editing = editing
        this.$emit('editing', editing)
      }
    },
    setResult(result) {
      this.sendEditEvent(false)
      this.selectedItem = result.fullAddress
      this.searchTerm = result.fullAddress
      this.isOpen = false
      this.arrowCounter = 0
    },
    clearNumber() {
      this.streetNumber = ''
      this.$emit('clear-item')
    },
    onArrowDown() {
      if (this.arrowCounter < this.items.length) {
        this.arrowCounter = this.arrowCounter + 1
      }
    },
    onArrowUp() {
      if (this.arrowCounter > 0) {
        this.arrowCounter = this.arrowCounter - 1
      }
    },
    onEnter() {
      if (this.isOpen) {
        const selectedItem = this.items[this.arrowCounter]
        this.searchTerm = selectedItem.fullAddress
        this.selectItem(selectedItem)
      }
    },
    handleClickOutside(evt) {
      if (!this.$el.contains(evt.target)) {
        this.isOpen = false
        this.arrowCounter = 0
      }
    },
    searchAutocomplete(input) {
      const requestPath = this.mountUrl(AUTOCOMPLETE_PATH, { input })
      return new Promise(resolve => {
        axios.get(requestPath).then(
          response => {
            const items = response.data.results
            resolve(items)
          },
          () => {
            resolve([])
          }
        )
      })
    },
    geocodeByPlaceId(placeId, number = '') {
      const requestPath = this.mountUrl(GEOCODE_PATH, { placeId, number })
      return new Promise(resolve => {
        axios.get(requestPath).then(
          result => {
            resolve(result.data)
          },
          () => {
            resolve({})
          }
        )
      })
    },
    geocodeByAddress(address) {
      const requestPath = this.mountUrl(GEOCODE_PATH, { address })
      return new Promise(resolve => {
        axios.get(requestPath).then(
          result => {
            resolve(result.data)
          },
          () => {
            resolve({})
          }
        )
      })
    },
    searchRepsol(address) {
      const apiUrl = this.config.apiUrl || this.apiUrl
      const requestPath = `${apiUrl}/${SEARCH_PATH}?streetType=${address.streetType}&street=${address.street}&number=${
        address.number
      }&locality=${address.locality}&municipality=${address.municipality}&province=${address.province}`
      return new Promise(resolve => {
        axios.get(requestPath).then(
          result => {
            resolve(merge(address, result.data))
          },
          () => {
            resolve({})
          }
        )
      })
    },
    parseFullAddress(fullAddress) {
      const result = { street: '', locality: '', country: '' }
      try {
        const splitAddress = fullAddress.split(',')
        for (let i = 0; i < splitAddress.length; i++) {
          if (i === 0) {
            result.street = splitAddress[i].trim()
          } else if (i === splitAddress.length - 2) {
            result.locality = splitAddress[i].trim()
          } else if (i === splitAddress.length - 1) {
            result.country = splitAddress[i].trim()
          }
        }
      } catch (err) {
        console.log('Error parsing address')
      }
      return result
    },
    trackerGAEvent(eventCategory, eventAction, eventLabel) {
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'eventoGA',
          eventCat: eventCategory,
          eventAct: eventAction,
          eventLbl: eventLabel
        })
      }
    },
    mountUrl(endPointType, data) {
      function addCanaryConfig(resultPath, config) {
        if (config.canarias) {
          resultPath += '&canarias=true'
        }
        if (config.islandToExclude) {
          resultPath += `&islandToExclude=${config.islandToExclude}`
        }
        return resultPath
      }

      let requestPath
      const apiUrl = this.config.apiUrl || this.apiUrl
      switch (endPointType) {
        case AUTOCOMPLETE_PATH:
          const { input } = data
          requestPath = `${apiUrl}/${AUTOCOMPLETE_PATH}?input=${encodeURIComponent(input)}&location=${
            this.locationFromSearch
          }&maxResults=${this.config.maxResults}&neutralAddress=true`
          requestPath = addCanaryConfig(requestPath, this.config)
          break
        case GEOCODE_PATH:
          const { placeId, number, address } = data
          requestPath = `${apiUrl}/${GEOCODE_PATH}`
          if (placeId && number) requestPath += `?placeId=${placeId}&number=${number}`
          if (address) requestPath += `?address=${address}`
          requestPath = addCanaryConfig(requestPath, this.config)
        default:
          break
      }
      return requestPath
    },
    concatNumberInGoogleAddress(gogoleAddress, number) {
      const addComponents = gogoleAddress.split(', ')
      return `${addComponents[0]}, ${number}, ${addComponents.slice(1).join(', ')}`
    }
  },
  mounted() {
    this.config = merge(this.defaultConfig, this.configuration)
    this.locationFromSearch = this.location || this.config.defaultLocation
    document.addEventListener('click', this.handleClickOutside)
  },
  destroyed() {
    document.removeEventListener('click', this.handleClickOutside)
  }
}



// WEBPACK FOOTER //
// ./autocomplete-component/src/AutocompleteComponent.view.js